import { EventTypeConstants } from "../_constants";

const initialState = {
  params: null,
  loading: false,
  items: [],
  error: undefined,
};

export function eventTypes(state = initialState, action) {
  switch (action.type) {
    case EventTypeConstants.FETCH_EVENT_TYPES_REQUEST: {
      const { params } = action;
      return {
        ...state,
        params,
        error: undefined,
        loading: true,
      };
    }

    case EventTypeConstants.FETCH_EVENT_TYPES_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        params: null,
        loading: false,
        error: undefined,
        items: payload,
      };
    }

    case EventTypeConstants.FETCH_EVENT_TYPES_FAILURE: {
      const { error } = action;
      return {
        ...state,
        params: null,
        loading: false,
        error,
      };
    }

    default:
      return state;
  }
}
